import { List } from "antd";
import { RightOutlined } from "@ant-design/icons";

const FAQOptionsList = ({
  faqDetails,
  openAiBotChat,
  setSltdFAQOption,
}) => {
  const handleFAQSelection = (item) => {
    setSltdFAQOption(item.category);
    openAiBotChat();
  };

  return (
    <div className="lists-faq-options">
      {faqDetails && (
        <List
          size="small"
          bordered
          className="list-for-faq"
          dataSource={faqDetails || []}
          renderItem={(item) => (
            <List.Item
              className="faq-list-item"
              onClick={() => {
                handleFAQSelection(item);
              }}
            >
              <div className="helpList">
                <div className="icon-option-list">
                  <div className="item-option-faq">{item.option}</div>
                </div>
                <RightOutlined style={{ color: "grey" }} />
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};
export default FAQOptionsList;
